module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_color-32e18c1a3b14380461ca792f673572ea.jpg";